import { formField } from '@ocp-zmarta/zmarta-cl'

const field = formField()
field.filters = ['uppercaseFirstLetter']
field.validation = { required: true }

export default field
